import React from 'react'
import PropTypes from 'prop-types'

import cn from '../../libs/class-name'

const Paragraph = ({ classNames, children, invert = false, size }) => (
  <p
    className={cn(
      'Paragraph',
      { invert, [`size-${size}`]: !!size },
      classNames
    )}
  >
    {children}
  </p>
)

Paragraph.propTypes = {
  classNames: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
  invert: PropTypes.bool,
  size: PropTypes.oneOf(['l', 'hero'])
}

export default Paragraph
